import { Element as ElementType } from '@/types';

export const initialElements: ElementType[] = [
  { id: 'water', name: 'Water', type: 'water' },
  { id: 'fire', name: 'Fire', type: 'fire' },
  { id: 'dirt', name: 'Dirt', type: 'dirt' },
  { id: 'air', name: 'Air', type: 'air' },
];